import React from "react";

import {
	FilterDatePicker,
	FilterDatePickerFromTo,
	FilterDatePickerRange,
	FilterDayHourMinuteInput,
	FilterInput,
	FilterInputDollar,
	FilterMinMaxAgePicker,
	FilterMonthYearPicker,
	FilterNumericRangeInput,
	FilterSelect,
} from "./components";

export const Column = ({ column }) => {
	if (column.type === "input") {
		return <FilterInput column={column} />;
	} else if (column.type === "input-dollar") {
		return <FilterInputDollar column={column} />;
	} else if (column.type === "select") {
		return <FilterSelect column={column} />;
	} else if (column.type === "date-picker") {
		return <FilterDatePicker column={column} />;
	} else if (column.type === "date-picker-from-to") {
		return <FilterDatePickerFromTo column={column} />;
	} else if (column.type === "daysHoursMinuteInput") {
		return <FilterDayHourMinuteInput column={column} />;
	} else if (column.type === "date-picker-range") {
		return <FilterDatePickerRange column={column} />;
	} else if (column.type === "month-year-picker") {
		return <FilterMonthYearPicker column={column} />;
	} else if (column.type === "minMaxAgePicker") {
		return <FilterMinMaxAgePicker column={column} />;
	} else if (column.type === "numeric-range") {
		return <FilterNumericRangeInput column={column} />;
	} else {
		return null;
	}
};

type DefaultLayoutProps = {
	columns: any[];
	className?: string;
};

export const DefaultLayout = ({ columns, className }: DefaultLayoutProps) => {
	return (
		<>
			{columns
				.flatMap(c => c)
				.map(column => {
					return <Column key={column.name} column={column} />;
				})}
		</>
	);
};

export const ExpandableLayout = ({ rows }) => {
	return (
		<>
			{rows.map((row, index) => {
				return (
					<div
						className="d-flex"
						key={`expandable-filter-row-${index}`}
					>
						<DefaultLayout columns={row} />
					</div>
				);
			})}
		</>
	);
};
